import React from 'react';
import { bool, shape, string } from 'prop-types';

const FieldGroupColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="6.75" width="9.75" height="1.5" fill="currentColor" />
    <rect x="7.5" y="3" width="9" height="1.5" fill="currentColor" />
    <rect x="12" y="7.5" width="4.5" height="1.5" fill="currentColor" />
    <rect x="9.75" y="6.75" width="1.5" height="9.75" fill="currentColor" />
    <rect x="1.5" y="13.5" width="11.25" height="1.5" fill="currentColor" />
    <rect x="3" y="5.25" width="1.5" height="11.25" fill="currentColor" />
    <rect x="9" y="1.5" width="1.5" height="4.5" fill="currentColor" />
    <rect x="13.5" y="1.5" width="1.5" height="9" fill="currentColor" />
  </svg>
);

FieldGroupColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default FieldGroupColor;
